import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAllpackageApi,
  createpackageApi,
  updatepackageApi,
  deletepackageApi,
} from "../../apis/curriculumManagement";

export const getAllpackages = createAsyncThunk("package/getAll", async () => {
  const response = await getAllpackageApi();
  return response.data.data;
});

export const createpackage = createAsyncThunk(
  "package/create",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await createpackageApi(formData);
      return response.data?.package;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to create course"
      );
    }
  }
);

export const updatepackage = createAsyncThunk(
  "package/update",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const response = await updatepackageApi(id, formData);
      return response.data?.package;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to update course"
      );
    }
  }
);

export const deletepackage = createAsyncThunk(
  "package/delete",
  async (id, { rejectWithValue }) => {
    try {
      await deletepackageApi(id);
      return id; // Return deleted subject ID to update state
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to delete subject"
      );
    }
  }
);

const packageSlice = createSlice({
  name: "packages",
  initialState: {
    packages: [],
    status: "idle",
    error: null,
  },
  reducers: {
    reset: (state) => {
      state.packages = [];
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllpackages.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAllpackages.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.packages = action.payload;
      })
      .addCase(getAllpackages.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      // create package
      .addCase(createpackage.pending, (state) => {
        state.status = "loading";
      })
      .addCase(createpackage.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.packages.push(action.payload);
      })
      .addCase(createpackage.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to create course.";
      })

      // delete
      .addCase(deletepackage.pending, (state) => {
        state.status = "loading";
      })
      .addCase(deletepackage.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.packages = state.packages.filter(
          (topicDelete) => topicDelete.id !== action.payload
        );
      })
      .addCase(deletepackage.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to delete  package.";
      })

      // update the package ---
      .addCase(updatepackage.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updatepackage.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.packages = state.packages.map((p) =>
          p.id === action.payload.id ? action.payload : p
        );
      })
      .addCase(updatepackage.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to update course.";
      });
  },
});
export default packageSlice.reducer;
